import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: !!localStorage.getItem("authToken"), // Check persistence
  user: JSON.parse(localStorage.getItem("authUser")) || null,
  token: localStorage.getItem("authToken") || null,
  
  showLoginModal: false,
  isLoading: false,
  error: null,

  // Temporary State for OTP Flow
  otpSent: false,
  tempUserId: null,
  tempSessionId: null,
  tempMobile: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    toggleLoginModal(state, action) {
      state.showLoginModal = action.payload !== undefined ? action.payload : !state.showLoginModal;
      // Reset temp state when closing
      if (!state.showLoginModal) {
        state.otpSent = false;
        state.error = null;
      }
    },

    hydrateAuth(state, action) {
      state.isLoggedIn = true;
      state.token = action.payload.token;
      state.user = action.payload.user;
    },

    // --- LOGIN (SEND OTP) ---
    loginRequest(state) {
      state.isLoading = true;
      state.error = null;
    },
    loginSuccess(state, action) {
      state.isLoading = false;
      state.otpSent = true;
      // Store temp data needed for verification/resend
      state.tempUserId = action.payload.user_id;
      state.tempSessionId = action.payload.session_id;
      state.tempMobile = action.payload.mobile;
    },
    loginFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // --- VERIFY OTP ---
    verifyOtpRequest(state) {
      state.isLoading = true;
      state.error = null;
    },
    verifyOtpSuccess(state, action) {
      state.isLoading = false;
      state.isLoggedIn = true;
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.showLoginModal = false; // Close modal
      
      // Clear temp data
      state.otpSent = false;
      state.tempUserId = null;
      state.tempSessionId = null;
      state.tempMobile = null;

      // Persist
      localStorage.setItem("authToken", action.payload.token);
      localStorage.setItem("authUser", JSON.stringify(action.payload.user));
    },
    verifyOtpFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // --- VERIFY TOKEN (APP AUTO LOGIN) ---
    verifyTokenRequest(state) {
      state.isLoading = true;
      state.error = null;
    },
    verifyTokenSuccess(state, action) {
      state.isLoading = false;
      state.isLoggedIn = true;
      state.user = action.payload.user;
      state.token = action.payload.token;

      localStorage.setItem("authToken", action.payload.token);
      localStorage.setItem("authUser", JSON.stringify(action.payload.user));
    },
    verifyTokenFailure(state, action) {
      state.isLoading = false;
      state.isLoggedIn = false;
      state.user = null;
      state.token = null;

      localStorage.removeItem("authToken");
      localStorage.removeItem("authUser");
    },


    // --- RESEND OTP ---
    resendOtpRequest(state) {
      state.isLoading = true;
      state.error = null;
    },
    resendOtpSuccess(state, action) {
      state.isLoading = false;
      // Update session ID if changed
      state.tempSessionId = action.payload.session_id;
    },
    resendOtpFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // --- LOGOUT ---
    logout(state) {
      state.isLoggedIn = false;
      state.user = null;
      state.token = null;
      localStorage.removeItem("authToken");
      localStorage.removeItem("authUser");
    },
  },
});

export const {
  toggleLoginModal,
  hydrateAuth,
  loginRequest, loginSuccess, loginFailure,
  verifyOtpRequest, verifyOtpSuccess, verifyOtpFailure,
  verifyTokenRequest, verifyTokenSuccess, verifyTokenFailure,
  resendOtpRequest, resendOtpSuccess, resendOtpFailure,
  logout
} = authSlice.actions;

export default authSlice.reducer;